import { useTheme } from "@emotion/react";

import { Message, MessageSections } from "../components/message/message";
import BarekamButton from "../components/button/barekam-button";
import { BarekamIcon } from "../components/icon/barekam-icon";
import { AuthIcons } from "../components/icon/variants";
import { AuthButtons } from "../components/button";
import BarekamText from "../components/text";

import { useAppSelector } from "../../redux/store";

const TypeSelectionBlock = ({setSelectedType, hideTitle = false, selectedType}: {setSelectedType: any, hideTitle?: boolean, selectedType?: number}) => {
    const { matchesPhone } = useAppSelector((state) => state.deviceReducer);
    const theme: any = useTheme();

    return (
      <>
      {!hideTitle && (
        <BarekamText variant={"xxl"} align={"center"} bold>
          <Message
            messageKey={"create_account"}
            sectionId={MessageSections.LOGIN}
          />
        </BarekamText>
      )}
    
        <div
          style={{
            display: "flex",
            gap: "1rem",
            width: "100%",
            flexDirection: matchesPhone ? "column" : "row",
          }}
        >
          <BarekamButton
            type={AuthButtons.TYPE_SELECT}
            size={"l"}
            onClick={() => setSelectedType(1)} 
            sx={{ border: selectedType === 1 ? `2px solid ${theme?.palette?.primary.main}` : "2px solid transparent" }}
          >
            <BarekamIcon variant={AuthIcons.personalAccount} />

            <BarekamText variant={"m"} fontWeight={500} align={"center"}>
              <Message
                messageKey={"personal_account"}
                sectionId={MessageSections.LOGIN}
              />
            </BarekamText>
          </BarekamButton>

          <BarekamButton
            type={AuthButtons.TYPE_SELECT}
            size={"l"}
            onClick={() => setSelectedType(2)}
            sx={{ border: selectedType === 2 ? `2px solid ${theme?.palette?.primary.main}` : "2px solid transparent" }}
          >
            <BarekamIcon variant={AuthIcons.companyAccount} />

            <BarekamText variant={"m"} fontWeight={500} align={"center"}>
              <Message
                messageKey={"company_account"}
                sectionId={MessageSections.LOGIN}
              />
            </BarekamText>
          </BarekamButton>
        </div>
      </>
    );
  };

  export default TypeSelectionBlock;